import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CancelIcon from '@material-ui/icons/Cancel';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex-direction',
        flexWrap: 'wrap',
    },
    title: {
        fontSize: 20,
    },
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    circularProgressbar: {
        maxWidth: 120
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
        height: 80,
    },
    error: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

export default function ConfirmationBox(props) {
    const { handleConfirm, handleCancel, title, msg, uploadingMessage, open, error } = props;
    const classes = useStyles();
    const intl = useIntl();
    const [fullWidth, setFullWidth] = React.useState(true);
    const [showUploading, setShowUploading] = React.useState(true);
    const [isError, setError] = React.useState(false);

    React.useEffect(() => {
        if (uploadingMessage === false) {
            setFullWidth(true);
            setShowUploading(false);
            setError(false);
        } else {
            setFullWidth(false);
            setShowUploading(true);
        }

        if (error === true) {
            setError(true);
        } else {
            setError(false);
        }
    }, [uploadingMessage, error]);

    return (
        <Dialog maxWidth='sm'
            fullWidth={fullWidth}
            onClose={handleCancel}
            aria-labelledby="confirmation-dialog-title"
            open={open}>
            {!showUploading ?
                ([
                    <DialogTitle id="confirmation-dialog-title" key="1">{title}</DialogTitle>,
                    <DialogContent key="2">
                        {msg}
                    </DialogContent>,
                    <DialogActions key="3">
                        <Button onClick={handleConfirm} variant="contained" color="primary">
                            {intl.formatMessage({ id: 'waring.ok' })}
                        </Button>
                        <Button onClick={handleCancel} variant="contained" >
                            {intl.formatMessage({ id: 'waring.no' })}
                        </Button>
                    </DialogActions>
                ])
                :
                ([
                    <DialogTitle id="confirmation-dialog-title" key="1">{title}</DialogTitle>,
                    <DialogContent key="2">
                        {isError ?
                            <Grid container spacing={0}>
                                <Grid item xs={12}>
                                    <div className={classes.error} style={{ height: 100 }}>
                                        <CancelIcon color="secondary" style={{ fontSize: 80 }} />
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className={classes.error}>
                                        <Button onClick={handleCancel} variant="contained" >
                                            {intl.formatMessage({ id: 'waring.ok' })}
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                            :
                            <div className={classes.circularProgress}>
                                <CircularProgress />
                            </div>
                        }
                    </DialogContent>
                ])
            }
        </Dialog>
    )
}